import { render, staticRenderFns } from "./text_to_freelancer.vue?vue&type=template&id=41f2448c&scoped=true&lang=pug&"
import script from "./text_to_freelancer.vue?vue&type=script&lang=js&"
export * from "./text_to_freelancer.vue?vue&type=script&lang=js&"
import style0 from "./text_to_freelancer.vue?vue&type=style&index=0&id=41f2448c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f2448c",
  null
  
)

export default component.exports